/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuleSetInfoDto
 */
export interface RuleSetInfoDto {
    /**
     * The id of the ruleset
     * @type {string}
     * @memberof RuleSetInfoDto
     */
    rulesetId?: string;
    /**
     * The new name for the ruleset
     * @type {string}
     * @memberof RuleSetInfoDto
     */
    name: string;
    /**
     * The new description for the ruleset
     * @type {string}
     * @memberof RuleSetInfoDto
     */
    description?: string;
}

/**
 * Check if a given object implements the RuleSetInfoDto interface.
 */
export function instanceOfRuleSetInfoDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function RuleSetInfoDtoFromJSON(json: any): RuleSetInfoDto {
    return RuleSetInfoDtoFromJSONTyped(json, false);
}

export function RuleSetInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleSetInfoDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rulesetId': !exists(json, 'rulesetId') ? undefined : json['rulesetId'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function RuleSetInfoDtoToJSON(value?: RuleSetInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rulesetId': value.rulesetId,
        'name': value.name,
        'description': value.description,
    };
}

